/** @format */

import * as React from 'react';

export const IconSport = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.47718 2 2 6.47718 2 12C2 17.5229 6.47718 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47718 17.5229 2 12 2ZM20.2703 11.1061L20.2662 11.1028C18.6554 10.9357 17.1292 10.2992 15.8771 9.27228L18.4315 6.71791C19.4606 7.96922 20.0999 9.49494 20.2703 11.1061ZM17.2517 5.54055L14.7006 8.09909C13.6734 6.84716 13.0368 5.32088 12.8701 3.71005C14.478 3.87932 16.0012 4.51564 17.2517 5.54055ZM11.2093 3.70588C11.3836 5.75997 12.1929 7.70891 13.5249 9.28227L11.9973 10.8099L6.73542 5.54803C8.01017 4.50242 9.56796 3.86103 11.2093 3.70588ZM5.55853 6.725L5.55474 6.72122L5.55892 6.72454C5.55876 6.72469 5.55864 6.72485 5.55853 6.725L10.8208 11.9864L9.29233 13.5149C7.71991 12.1823 5.7714 11.3726 3.71762 11.1984C3.87246 9.55735 4.51346 7.99975 5.55853 6.725ZM3.72425 12.8667V12.8634C5.33508 13.0301 6.86136 13.6667 8.11329 14.6939L5.55892 17.2483C4.53253 15.9983 3.89473 14.4751 3.72425 12.8667ZM6.73873 18.4248L9.28979 15.8704C10.317 17.1223 10.9536 18.6486 11.1203 20.2594C9.51195 20.089 7.98872 19.4512 6.73873 18.4248ZM12.7853 20.2669C12.6113 18.2128 11.8016 16.264 10.4688 14.6914L11.9973 13.1629L17.2592 18.4248C15.9846 19.4707 14.4267 20.1122 12.7853 20.2669ZM18.434 17.2483L13.1738 11.9864L14.7014 10.4588C16.2743 11.7905 18.2226 12.5998 20.2761 12.7744C20.121 14.4157 19.4796 15.9735 18.434 17.2483Z"
        fill="#313140"
      />
    </svg>
  );
};
